export enum ReelSetName {
	FreeGame = "FreeGame",
	BaseGame = "BaseGame",
}
